import { Box, ButtonNew, ColorOptions, IconNew, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC } from 'react'
import { Dimensions } from 'react-native'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { styles } from './styles'
const ImageLanding = require('../../assets/svg/pos-device.svg')
const ImageLandingTab = require('../../assets/images/home-screen/jio-marketing-banner-tab.png')

export const PosSection: FC = () => {
  const { headerSize } = useFontSize()
  const navigate = useNavigation().navigate
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)

  const onContactUsClicked = () => {
    navigate('contact')
  }

  const isMob = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)

  const returnImageStyle = () => {
    if (isMob) {
      return { ...imageStyle.portaitImageStyle }
    } else if (isTab) {
      return { ...imageStyle.portaitTabImageStyle }
    } else {
      return { ...imageStyle.wide }
    }
  }

  const returnImage = () => {
    if (isMob) {
      return ImageLanding
    } else if (isTab) {
      return ImageLandingTab
    } else {
      return ImageLanding
    }
  }

  return (
    <Box {...themedStyle.content}>
      <Box {...themedStyle.boxLanding}>
        <Box {...themedStyle.titleContainer}>
          <Box flexDirection={'row'} align={'center'}>
            <IconNew id={'POS'} size={isMob ? 24 : 32} color={'WHITE'} />
            <Spacer direction="horizontal" size={16} />
            <Text
              fontFamily="jiotype-medium"
              fontSize={isMob ? 12 : 18}
              color={'WHITE'}
              letterSpacing={isMob ? 3.2 : 5.6}
              lineHeight={isMob ? 32 : isTab ? 18 : 32}>
              {'POINT OF SALE'}
            </Text>
            <Spacer direction="horizontal" size={16} />
            <Box h={'1'} bg={'WHITE'} w={48} />
          </Box>
          <Spacer direction="vertical" size={16} />
          <Text
            fontFamily="jiotype-black"
            fontSize={headerSize}
            color={'WHITE'}
            lineHeight={isMob ? 36 : isTab ? 38 : 66}>
            {staticStrings.posSubTitle}
          </Text>
        </Box>
        <Spacer direction="vertical" size={isMob ? 8 : 12} />
        <Box {...themedStyle.buttonBox}>
          <ButtonNew {...themedStyle.button} onPress={onContactUsClicked} hoverColor={colors.HIGHLIGHT as ColorOptions}>
            <Text title={staticStrings.contact} fontFamily={'jiotype-bold'} color={'WHITE'} fontSize={14} />
          </ButtonNew>
        </Box>
        <Spacer direction="vertical" size={isMob ? 64 : 64} />
      </Box>
      <ModBox show={isMob} {...themedStyle.imageBox} {...themedStyle.imageBoxFix}>
        <Image resizeMode="contain" source={returnImage()} {...returnImageStyle()} />
      </ModBox>
    </Box>
  )
}

const width = Dimensions.get('window').width

const imageStyle = {
  portaitImageStyle: {
    height: '100%',
    width: width,
  },
  wide: {
    width: 541,
    height: 537,
    top: 0,
    left: 0,
  },
  portaitTabImageStyle: {
    width: 496,
    height: 600,
  },
}
